import {useCompanyFeatureEntitlement} from '@product-web/shared--entitlement/use-feature-entitlement'

export function useIsEntitledToAPIKeys() {
    const {isEntitled, isLoading} = useCompanyFeatureEntitlement('PLEO_PUBLIC_API_KEYS')

    return {isEntitled, isLoading}
}
